import type { CompanyType } from '@/types/Activity'

interface Props {
  companyType: CompanyType
}

const OrganisationType: React.FC<Props> = ({ companyType }) => {
  switch (companyType) {
    case 'PrivateLimitedCompany':
      return <p>Private Limited Company</p>
    case 'PrivateLimitedCompanyByGuaranteeWithoutShareCapital':
      return <p>Private Limited Company by Guarantee without Share Capital</p>
    case 'PrivateLimitedCompanyByGuaranteeWithoutShareCapitalUseOfLimitedExemption':
      return (
        <p>
          Private Limited Company by Guarantee without Share Capital, use of 'Limited'
          exemption
        </p>
      )
    case 'PublicLimitedCompany':
      return <p>Public Limited Company</p>
    case 'LimitedLiabilityPartnership':
      return <p>Limited Liability Partnership</p>
    case 'OverseasCompanyRequiredToPublishAccountsUnderParentLaw':
      return <p>Overseas Company required to publish accounts under parent law</p>
    case 'CharitableIncorporatedOrganisation':
      return <p>Charitable Incorporated Organisation</p>
    case 'CooperativeAndCommunityBenefitSocietyWithCharitableStatus':
      return <p>Cooperative And Community Benefit Society With Charitable Status</p>
    default:
      return <p></p>
  }
}

export default OrganisationType
